import {
    FEATURE_SOURCE,
    GEOJSON_FEATURE_COLLECTION,
    GEOJSON_PROPERTY,
    STATIC_ZOOM
} from './constants';
import type { Feature, GeoJSONSource, LayerStyle, Map } from './types';

const staticLayers = () => {
    const initialize = (map: Map, staticStyles?: LayerStyle[]) => {
        initializeStaticSource(map);

        if (!staticStyles) {
            return;
        }

        initializeStaticLayers(map, staticStyles);
    };

    const initializeStaticSource = (map: Map) => {
        map.addSource(FEATURE_SOURCE.STATIC, {
            data: {
                features: [],
                type: GEOJSON_FEATURE_COLLECTION
            },
            type: 'geojson'
        });
    };

    const initializeStaticLayers = (map: Map, staticStyles: LayerStyle[]) => {
        staticStyles.forEach(staticStyle => addStaticLayer(map, staticStyle));
    };

    const addStaticLayer = (map: Map, staticStyle: LayerStyle) => {
        const { filter, name, style, type } = staticStyle;

        map.addLayer({
            filter: ['==', ['get', 'layer'], filter ?? name],
            id: name,
            layout: {},
            maxzoom: STATIC_ZOOM.max,
            minzoom: STATIC_ZOOM.min,
            paint: style,
            source: FEATURE_SOURCE.STATIC,
            type
        });
    };

    const updateFeatures = (map: Map, features: Feature[]) => {
        const staticSource = map.getSource(FEATURE_SOURCE.STATIC) as GeoJSONSource;

        if (staticSource) {
            const staticFeatures = features.filter(
                feature => feature.properties?.[GEOJSON_PROPERTY.IS_STATIC]
            );

            staticSource.setData({
                features: staticFeatures,
                type: GEOJSON_FEATURE_COLLECTION
            });
        }
    };

    return {
        initialize,
        updateFeatures
    };
};

export default staticLayers;
